import React, { useEffect, useState, useContext } from 'react';
import { MdChevronRight } from 'react-icons/md';

import MenuContext from '../Menu.Context';
import MenuItem from '../MenuItem/MenuItem.styled';
import { Chevron, DropdownArea, Wrapper } from './Dropdown.styled';

interface Props {
  children?: React.ReactNode;
  label: string;
}

function Dropdown({ children, label }: Props): React.ReactElement {
  const [childIds, setChildIds] = useState<Array<string>>([]);
  const context = useContext(MenuContext);

  useEffect(() => {
    if (children) {
      const ids = React.Children.map(children, (child: React.ReactNode) => {
        if (child && typeof child !== 'string') {
          const { id } = (child as JSX.Element).props;
          return id;
        }
      });

      if (ids) setChildIds(ids);
    }
  }, [children]);

  const isActive = childIds.some((id) => id === context.activeId);

  return (
    <Wrapper>
      <MenuItem className={isActive ? 'active' : ''}>
        <Chevron>
          <MdChevronRight />
        </Chevron>
        {label}
      </MenuItem>
      <DropdownArea>{children}</DropdownArea>
    </Wrapper>
  );
}

export default Dropdown;
